export default __webpack_public_path__ + "static/media/assets-wanted.720527d5.jpg";